/**
* Nav CTAs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Nav CTAs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'nav-ctas',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.nav-ctas' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--nav-ctas' )[0], {
          pagination: false,
          arrows: false,
          gap: '20px',
          perPage: 1,
          perMove: 1,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'nav-ctas', COMPONENT );
} )( app );
